import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useWebsites } from "@/context/WebsitesContext";
import { useSettings } from "@/context/SettingsContext";
import { useWordPress } from "@/context/WordPressContext";

const DashboardRecommendations: React.FC = () => {
  const navigate = useNavigate();
  const { currentWebsite } = useWebsites();
  const { isAutomatedWeeklyPlanningActive } = useSettings();
  const { settings: wpSettings } = useWordPress();

  useEffect(() => {
    console.log("🌺 isAutomatedWeeklyPlanningActive", isAutomatedWeeklyPlanningActive);
  }, [isAutomatedWeeklyPlanningActive]);

  return (
    <div className="w-full">
      {/* WordPress Integration Section */}
      {currentWebsite?.cms === "wordpress" && !wpSettings?.is_connected && (
        <div className="space-y-3">
          <div className="bg-gradient-to-r from-primary/5 via-primary/10 to-primary/5 border border-primary/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Link className="h-4 w-4 text-primary" />
              </div>
              <div className="space-y-3 flex-grow">
                <div className="space-y-1">
                  <h3 className="text-sm font-semibold text-primary">
                    Connect Your WordPress Site
                  </h3>
                  <p className="text-xs text-muted-foreground">
                    Automatically publish your AI-generated content and streamline your workflow.
                  </p>
                </div>
                <Button
                  variant="default"
                  size="sm"
                  onClick={() => navigate('/settings#wordpress')}
                  className="space-x-2"
                >
                  <span>Set up WordPress Integration</span>
                  <ArrowRight className="h-3 w-3" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardRecommendations;